import styled from '@emotion/styled';
import { mq } from 'src/themes';
import { SvgIcon, Typography } from 'src/components/atoms';

interface Props {
  icon: JSX.Element;
  value: number | string;
}

const StyledSingleIcon = styled.div`
  display: flex;
  align-items: center;
  margin-right: 1rem;

  ${mq.sm} {
    margin-right: 0.375rem;
  }
`;

export const SingleIcon = ({ icon, value }: Props) => {
  return (
    <StyledSingleIcon>
      <SvgIcon sx={{ mr: 0.5 }}>{icon}</SvgIcon>
      <Typography variant='body2'>{value || 0}</Typography>
    </StyledSingleIcon>
  );
};
